var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"no-underline block",attrs:{"to":{ name: 'broker-home' },"tag":"a"}},[_c('img',{staticStyle:{"height":"80px","margin-top":"-5px"},attrs:{"src":"/static/img/brokerpad-logo.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }